import Lenis from '@studio-freight/lenis';

export const smoothScroll = () => {
	const lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		direction: 'vertical', // vertical, horizontal
		gestureDirection: 'vertical', // vertical, horizontal, both
		smooth: true,
		mouseMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 2,
		infinite: false,
	});

	// Get scroll value
	lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
		// console.log({ scroll, limit, velocity, direction, progress });
	});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);
};

smoothScroll();


/*
	anchor link smoothscroll e.g. back to top
*/
export const smoothScroll_links = () => {

	document.querySelectorAll('a[href^="#"]').forEach(anchor => {

		if (anchor.classList.contains('js-overlay-trigger-newsletter') || anchor.classList.contains('js-overlay-trigger')) {
			//do nothing
		}else{

			anchor.addEventListener('click', function (e) {
				e.preventDefault();

				document.querySelector(this.getAttribute('href')).scrollIntoView({
					behavior: 'smooth'
				});
			});
		}
	});
}

smoothScroll_links();